import {DataFetcher} from '@aboutyou/data-fetcher';
import {RouterErrorHandler} from '@aboutyou/router';
import React from 'react';
import {useGetMetaData} from '../Meta/useGetMetaData';
import {PageMetaDataJsonLdView} from './PageMetaDataJsonLdView';

export const PageMetaDataJsonLd = () => {
  return (
    <DataFetcher
      request={useGetMetaData()}
      Error={RouterErrorHandler}
      View={PageMetaDataJsonLdView}
    />
  );
};
